"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = void 0;

/**
 * The Vanilla theme types.
 */
var Theme;
exports.Theme = Theme;

(function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
})(Theme || (exports.Theme = Theme = {}));